import React from 'react';
import { generateAllSchemas } from '../utils/schemaMarkup';

/**
 * SchemaMarkup component for rendering JSON-LD structured data
 * Enhances SEO, AIO, and AEO by providing structured data to search engines and AI
 */
const SchemaMarkup = ({ communityData, floorplans }) => {
  // Generate combined schema markup with @graph
  const schema = generateAllSchemas(communityData, floorplans);

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema, null, 2) }}
    />
  );
};

export default SchemaMarkup;